import { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { Redirect } from "react-router-dom";
import ValidadorDeProductos from './ValidadorDeProductos';

const Redireccion = (props) => {
    const [guid, setGuid] = useState(null);

    useEffect(() => {
        setGuid(props.match.params.guid);
    }, [props.match.params.guid]);

    return (
        <div>
            {guid != null &&
                <BrowserRouter>
                    <Redirect to={{
                        pathname: "/verificacion",
                        state: { guid: guid }
                    }} />
                    <Route
                        exact
                        path='/verificacion'
                        component={ValidadorDeProductos} />
                </BrowserRouter>
            }
        </div>
    );
}

export default Redireccion;